import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  locale: 'en-us',
  messages: {}
};

const setLocale = (draft, action) => {
  draft.locale = action.payload.locale;
};

const setMessages = (draft, action) => {
  draft.messages = action.payload.translations;
};

const intlSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setLocale,
    setMessages
  }
});
export const {
  actions
} = intlSlice;
export const plug = {
  [stateName]: intlSlice.reducer
};
export default intlSlice.reducer;